<template>
	<div class="container">
    <template v-for="item in dataList">
      <div class="layout-main" :key="item.id">
        <div class="title-group" v-if="item.subTitle">
          <h1>{{ item.title }}</h1>
          <h6>{{ item.subTitle }}</h6>
        </div>
        <div
          class="layout-box"
          :class="{ end: item.direction === 'right' }"
          :style="item.background ? 'background-image:url(' + item.background + ');' : ''"
        >
          <div
            class="picture-box"
            :style="item.textList && item.textList.length?'flex: 1':'width: 840px;'"
            :class="{
              right: item.direction === 'right',
              left: item.direction === 'left'
            }"
          >
            <el-image
              :src="item.image"
              class="picture"
              :style="item.textList && item.textList.length?'flex: 1':'width: 840px;'"
              lazy
            ></el-image>
          </div>
          <div class="space-box"></div>
          <div v-if="item.textList && item.textList.length" class="text-list">
            <div class="list" v-for="(list, index) in item.textList" :key="index">
              <div class="icon-title">
                <div class="icon">
                  <img :src="list.icon" :alt="list.smallTitle">
                </div>
                <div class="title">{{ list.smallTitle }}</div>
              </div>
              <p class="text">{{ list.text }}</p>
            </div>
          </div>
          <div v-else class="title-button">
            <h1>{{ item.title }}</h1>
            <div class="text">
              <p>{{ item.text }}</p>
            </div>
            <div
              v-if="btnTitle == '免费试用' && item.showBtn"
              class="btn-box"
            >
              <a href="#">
                <el-button
                  class="button"
                  @click="onLogin"
                  :class="{
                    purple: item.color === 'purple',
                    orange: item.color === 'orange'
                  }"
                >
                  <span class="text">免费试用</span>
                  <img
                    src="https://static.bimcc.com/openim/Vector%20%281%292FA15820D87AC2281F84B3012DF7C512.png"
                    class="icon"
                  />
                  <img
                    src="https://static.bimcc.com/openim/Vector%20%282%29714B12AA51FC5CF95A0CAD35ABD9BC85.png"
                    class="icon"
                  />
                </el-button>
              </a>
            </div>
            <!-- <div
              v-if="btnTitle == '试用'"
              class="button-box"
            >
              <a href="#">
                <el-button
                  class="button"
                  @click="onLogin"
                  >试用<i class="el-icon-right right-icon"></i
                ></el-button>
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </template>
	</div>
</template>

<script>
import { Image } from 'element-ui';
import { getToken } from '@/utils/tools';
export default {
	name: 'LrLayoutT',
	components: {
		'el-image': Image
	},
	props: {
		dataList: {
			type: Array,
			required: true,
			default: () => {
				return [];
			}
		},
		// 按钮文字
		btnTitle: {
			type: String,
			required: true,
			default: ''
		}
	},
	data() {
		return {};
	},
	methods: {
		onLogin() {
			const token = getToken();
			if (!token) {
				this.$message({
					message: '您还未登录，请先登录',
					type: 'info'
				});
				window.location.href = 'https://saas.bimcc.com/login';
				return;
			}
			const userInfo = localStorage.getItem('userInfo');
			if (userInfo) {
				window.location.href = 'https://saas.bimcc.com/home?chooseApps';
			} else {
				window.location.href = 'https://saas.bimcc.com/login?index=1';
			}
		}
	}
};
</script>

<style lang="less" scoped>
.end {
	flex-direction: row-reverse;
}
.right {
	transform: translateX(57px);
}
.left {
	transform: translateX(-57px);
}
.orange {
	background: linear-gradient(94.06deg, #f09e24 17.13%, #ffd363 98.96%);
}
.purple {
	background: linear-gradient(94.06deg, #7ca1ff 17.13%, #b8acfe 98.96%);
}
.layout-main {
  display: flex;
  flex-direction: column;
  gap: 52px;
  .title-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    h1 {
      color: #131314;
      text-align: center;
      font-family: "Source Han Sans CN";
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 48px;
    }
    h6 {
      color: #19213D;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 30px;
    }
  }
}
.text-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 456px;
  width: 522px;
  padding: 8px 0;
  box-sizing: border-box;
  .list {
    display: flex;
    padding: 28px;
    box-sizing: border-box;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    gap: 6px;
    border-radius: 16px;
    .icon-title {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
      .icon {
        width: 40px;
        height: 40px;
        img {
          width: 40px;
          height: 40px;
        }
      }
      .title {
        color: #131314;
        font-family: "PingFang SC";
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        letter-spacing: 0.5px;
      }
    }
    .text {
      color: #707786;
      font-family: "PingFang SC";
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px;
      letter-spacing: 0.5px;
    }
  }
}
.layout-box {
	display: flex;
	justify-content: space-between;
	position: relative;
	padding: 10px 1% 70px 1%;
	box-sizing: border-box;
	background-size: 100% 100%;
	background-repeat: no-repeat;
	text-align: left;
	.picture-box {
		flex: 1;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.title-button {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		width: 400px;
		height: 427.5px;
		h1 {
			padding-bottom: 8px;
			box-sizing: border-box;
			color: #131314;
			font-size: 32px;
			font-family: SourceHanSansCN-Bold, SourceHanSansCN;
			font-weight: bold;
			line-height: 48px;
			letter-spacing: 1px;
		}
		.text {
			padding-bottom: 48px;
			box-sizing: border-box;
			p {
				color: #2a2f3d;
				font-size: 20px;
				font-family: SourceHanSansCN-Medium, SourceHanSansCN;
				font-weight: 400;
				line-height: 32px;
			}
		}
		.btn-box {
			.el-button:hover {
				background: linear-gradient(94.06deg, #9e8ff0 10.96%, #aebde6 80.13%);
				img {
					transform: translateX(5px);
					transition-duration: 0.15s;
				}
			}
			.button {
				width: 152px;
				height: 52px;
				padding: 11px 54px 11px 18px;
				box-sizing: border-box;
				border-radius: 6px;
				.text {
					padding-right: 22px;
					box-sizing: border-box;
					color: #ffffff;
					font-size: 20px;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 400;
					line-height: 30px;
				}
			}
		}
		.button-box {
			.el-button:hover {
				i {
					transform: translateX(7px);
					transition-duration: 0.15s;
				}
			}
			.button {
				width: 128px;
				height: 40px;
				padding: 8px 16px 8px 20px;
				box-sizing: border-box;
				border: 1px solid #337eff;
				background: rgba(51, 126, 255, 0);
				color: #337eff;
				font-size: 16px;
				font-family: SourceHanSansCN-Regular, SourceHanSansCN;
				font-weight: 400;
				text-align: left;
				line-height: 24px;
				border-radius: 8px;
				.right-icon {
					padding-left: 40px;
					box-sizing: border-box;
				}
			}
		}
	}
}
</style>
